// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Pxpz","inputWrap":"Table_inputWrap__ITqZP","col":"Table_col__ajo1t","bmiTooltip":"Table_bmiTooltip__3C4Vz"};